import { Swiper, SwiperSlide } from "swiper/react";
import Banner from "../assets/images/cctv.png";
import Alarm from "../assets/images/firalarm.png"
import Cable from "../assets/images/cab.png"
import Assess from "../assets/images/cont.png"
import Phon from "../assets/images/phon.png"
import Inverter from "../assets/images/invert.png"
import HomeAuto from "../assets/images/homeautomate.png"
import { Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";

export default () => {
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={50}
      slidesPerView={1}
      loop={true}
      // onSlideChange={() => console.log("slide change")}
      // onSwiper={(swiper) => console.log(swiper)}
      autoplay={{
        delay: 4000, // Delay in milliseconds between slides
        disableOnInteraction: false, // Whether to disable autoplay on interaction
      }}
    >
      <SwiperSlide>
        <img
          src={Banner}
          alt=""
          className="mx-auto w-[250px] sm:w-auto max-w-fit object-cover"
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src={Alarm}
          alt=""
          className="mx-auto w-[250px] sm:w-auto max-w-fit object-cover"
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src={Cable}
          alt=""
          className="mx-auto w-[250px] sm:w-auto max-w-fit object-cover"
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src={Assess}
          alt=""
          className="mx-auto w-[250px] sm:w-auto max-w-fit object-cover"
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src={Phon}
          alt=""
          className="mx-auto w-[250px] sm:w-auto max-w-fit object-cover"
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src={Inverter}
          alt=""
          className="mx-auto w-[250px] sm:w-auto max-w-fit object-cover"
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src={HomeAuto}
          alt=""
          className="mx-auto w-[250px] sm:w-auto max-w-fit object-cover"
        />
      </SwiperSlide>
      ...
    </Swiper>
  );
};
